import { render, staticRenderFns } from "./LanguageRadioGroup.vue?vue&type=template&id=0319b80a&scoped=true&"
import script from "./LanguageRadioGroup.vue?vue&type=script&lang=js&"
export * from "./LanguageRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./LanguageRadioGroup.vue?vue&type=style&index=0&id=0319b80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319b80a",
  null
  
)

export default component.exports